import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div>
            <div className="footer-brand-logo">EXPERT ADV.</div>
            <div className="footer-brand-sub">India's Signage Experts</div>
            <p className="footer-desc">
              Expert Advertising India is a premier signage and advertising solutions company
              delivering innovative branding experiences across India since 2002. From LED signs
              to large-format hoardings, we bring your brand to life.
            </p>
            <div className="footer-socials">
              {[
                { icon: 'fab fa-facebook-f', href: '#' },
                { icon: 'fab fa-instagram', href: '#' },
                { icon: 'fab fa-linkedin-in', href: '#' },
                { icon: 'fab fa-youtube', href: '#' },
                { icon: 'fab fa-twitter', href: '#' },
              ].map((s, i) => (
                <a key={i} href={s.href} className="social-btn" aria-label="Social">
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div className="footer-heading">Quick Links</div>
            <ul className="footer-links">
              {[
                { to: '/', label: 'Home' },
                { to: '/services', label: 'Our Services' },
                { to: '/products', label: 'Products' },
                { to: '/about', label: 'About Us' },
                { to: '/clients', label: 'Our Clients' },
                { to: '/contact', label: 'Contact Us' },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="footer-link">
                    <i className="fas fa-chevron-right"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <div className="footer-heading">Our Services</div>
            <ul className="footer-links">
              {[
                'LED Sign Boards',
                'ACP Signage',
                'Neon Signs',
                'Hoardings & Billboards',
                'Wayfinding Systems',
                'Digital Displays',
                'Vehicle Branding',
                'Exhibition Stalls',
              ].map(s => (
                <li key={s}>
                  <Link to="/services" className="footer-link">
                    <i className="fas fa-chevron-right"></i>
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="footer-heading">Contact Us</div>
            <div className="footer-contact-item">
              <i className="fas fa-map-marker-alt footer-contact-icon"></i>
              <div className="footer-contact-text">
                <strong>Address</strong>
                Plot No. 45, Industrial Area, Phase II,<br />
                New Delhi – 110020, India
              </div>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-phone footer-contact-icon"></i>
              <div className="footer-contact-text">
                <strong>Phone</strong>
                +91 98100 12345<br />
                +91 11 4567 8901
              </div>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-envelope footer-contact-icon"></i>
              <div className="footer-contact-text">
                <strong>Email</strong>
                info@expertadvindia.com<br />
                sales@expertadvindia.com
              </div>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-clock footer-contact-icon"></i>
              <div className="footer-contact-text">
                <strong>Working Hours</strong>
                Mon–Sat: 9:30 AM – 7:00 PM
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copy">
            © {new Date().getFullYear()} Expert Advertising India. All rights reserved.
            Made with <span style={{ color: '#D4A017' }}>♥</span> in India.
          </div>
          <div className="footer-copy">
            <a href="#" style={{ color: 'rgba(255,255,255,0.3)', marginRight: 16 }}>Privacy Policy</a>
            <a href="#" style={{ color: 'rgba(255,255,255,0.3)' }}>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
